import { Box, Button, DangerButton, PrimaryButton } from "@nulogy/components";
import DeleteConfirmationModal from "components/common/DeleteConfirmationModal";
import useDeleteConfirmationModal from "hooks/state/useDeleteConfirmationModal";
import React from "react";

function FormButtons({
  cancelUrl = "/",
  saveButtonText = "Save",
  deleteConfirmationMessage,
  onCancel,
  onDelete,
  disabled,
}) {
  const { open: openModal } = useDeleteConfirmationModal();
  const deleteMessage = deleteConfirmationMessage || "Are you sure you want to delete this?";

  const handleDelete = (e) => {
    openModal(e);
  };

  const cancelProps = onCancel ? { onClick: onCancel } : { asLink: true, href: cancelUrl };

  return (
    <Box marginBottom="x2">
      <DeleteConfirmationModal message={deleteMessage} onDelete={onDelete} title="Delete" />
      {onDelete && (
        <DangerButton data-testid="delete-button" mr="x1" onClick={handleDelete} type="button">
          Delete
        </DangerButton>
      )}
      <PrimaryButton data-testid="save-button" disabled={disabled} mr="x1" type="submit">
        {saveButtonText}
      </PrimaryButton>
      <Button type="button" {...cancelProps}>
        Cancel
      </Button>
    </Box>
  );
}

export default FormButtons;
